import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Slider, Stack, Typography } from "@mui/material";
import { useId, useState } from "react";
import { useFormContext } from "react-hook-form";
import { FormatPercent } from "./formatters";
import { Input } from "./Input";
export const SliderInput = (props)=>{
    const labelId = useId();
    const formContext = useFormContext();
    const [tempValue, setTempValue] = useState();
    const formValue = formContext.watch(props.name);
    const displayValue = tempValue !== undefined ? tempValue : formValue;
    const onChange = (_, value)=>{
        setTempValue(value);
    };
    const onChangeCommitted = (_, value)=>{
        formContext.setValue(props.name, value, {
            shouldValidate: true
        });
        setTempValue(undefined);
        props.onChangeCommitted?.();
    };
    return /*#__PURE__*/ _jsxs(Stack, {
        width: "100%",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                "data-component": "text",
                "data-testid": `${props['data-testid'] ?? props.name}Label`,
                id: labelId,
                mb: 1,
                variant: "subtitle1",
                children: props.label
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                alignItems: "center",
                direction: "row",
                spacing: 4,
                width: "100%",
                children: [
                    /*#__PURE__*/ _jsx(Input, {
                        ...props,
                        "aria-labelledby": labelId,
                        hideError: true,
                        label: "",
                        sx: {
                            width: 72
                        }
                    }),
                    /*#__PURE__*/ _jsx(Slider, {
                        "aria-disabled": !!props.disabled,
                        "aria-labelledby": labelId,
                        "aria-live": "polite",
                        "aria-valuemax": props.max,
                        "aria-valuemin": props.min,
                        "data-component": "slider",
                        "data-testid": props['data-testid'] ?? props.name,
                        disabled: props.disabled,
                        max: props.max,
                        min: props.min,
                        onChange: onChange,
                        onChangeCommitted: onChangeCommitted,
                        role: "slider",
                        step: props.step ?? 1,
                        sx: {
                            color: props.color
                        },
                        value: displayValue,
                        valueLabelDisplay: "off"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Stack, {
                alignItems: "end",
                children: props.showMaxLabel && props.max !== undefined && /*#__PURE__*/ _jsxs(Typography, {
                    color: formValue > props.max ? 'error' : 'primary',
                    variant: "subtitle2",
                    children: [
                        "Max ",
                        /*#__PURE__*/ _jsx(FormatPercent, {
                            value: props.max
                        })
                    ]
                })
            })
        ]
    });
};
SliderInput.displayName = 'SliderInput';

//# sourceMappingURL=SliderInput.js.map